export default "__VITE_ASSET__$FWZDgIl__"